import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10 theme-transition relative z-10" style={{background: 'var(--liquid-bg-secondary)'}}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 liquid-glass-strong rounded-xl flex items-center justify-center">
                <span className="font-bold text-lg" style={{color: 'var(--liquid-text-primary)'}}>S</span>
              </div>
              <span className="font-bold text-lg" style={{color: 'var(--liquid-text-primary)'}}>ShufeShow</span>
            </div>
            <p className="text-sm opacity-70" style={{color: 'var(--liquid-text-muted)'}}>
              Your premier destination for event tickets in Jordan.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4" style={{color: 'var(--liquid-text-primary)'}}>Platform</h4>
            <ul className="space-y-2" style={{color: 'var(--liquid-text-muted)'}}>
              <li>
                <button onClick={() => navigate('/')} className="hover:underline transition-colors text-left" style={{color: 'inherit'}}>
                  Discover Events
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/about')} className="hover:underline transition-colors text-left" style={{color: 'inherit'}}>
                  About Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4" style={{color: 'var(--liquid-text-primary)'}}>Support</h4>
            <ul className="space-y-2" style={{color: 'var(--liquid-text-muted)'}}>
              <li>
                <a href="mailto:support@shufeshow.com" className="hover:underline transition-colors" style={{color: 'inherit'}}>
                  Contact Us
                </a>
              </li>
              <li>
                <button onClick={() => navigate('/about')} className="hover:underline transition-colors text-left" style={{color: 'inherit'}}>
                  Help Center
                </button>
              </li>
              <li>
                <a href="https://www.shufeshow.com" target="_blank" rel="noopener noreferrer" className="hover:underline transition-colors" style={{color: 'inherit'}}>
                  Website
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4" style={{color: 'var(--liquid-text-primary)'}}>Company</h4>
            <ul className="space-y-2" style={{color: 'var(--liquid-text-muted)'}}>
              <li>
                <button onClick={() => navigate('/about')} className="hover:underline transition-colors text-left" style={{color: 'inherit'}}>
                  About Us
                </button>
              </li>
              <li>
                <a href="mailto:info@shufeshow.com" className="hover:underline transition-colors" style={{color: 'inherit'}}>
                  Contact
                </a>
              </li>
              <li>
                <button onClick={() => navigate('/about')} className="hover:underline transition-colors text-left" style={{color: 'inherit'}}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm" style={{color: 'var(--liquid-text-muted)'}}>
            © 2024 ShufeShow Platform. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 sm:mt-0">
            <span className="text-sm" style={{color: 'var(--liquid-text-muted)'}}>Made with ❤️ in Jordan</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




